import React, { ReactElement } from 'react';
import { Redirect } from 'react-router-dom';
import { useAuthContext } from 'contexts/AuthContext';

interface RoleGuardProps {
  children: ReactElement;
  allowedRoles?: string[];
  allowedAccessTypes?: string[];
}

function RoleGuard(props: RoleGuardProps) {
  const { children, allowedRoles, allowedAccessTypes } = props;
  const { auth } = useAuthContext();

  if (!auth?.token) {
    return <Redirect to="/connexion" />;
  }

  if (allowedRoles && !allowedRoles.includes(auth?.user.role || '')) {
    return <Redirect to="*" />;
  }

  if (
    allowedAccessTypes &&
    !allowedAccessTypes.includes(auth?.user.accessType || '')
  ) {
    return <Redirect to="*" />;
  }

  return children;
}

export default RoleGuard;
